/**
 * WS2 strangle: the AngularJS ng-redux `state.views.stories` slice (the account-v2
 * stories REDUCER — recommendations / quoteOfTheDay / broadcastWorthy* etc.) was
 * read by exactly ONE consumer: the `[StoryModal].OpenStory` run-block's
 * `isUpgradedLibrary` branch (angularjs.module.ts), which loads recommendations
 * before opening the story modal. Moved that slice to a native NgRx feature so it
 * leaves the ng-redux store. REUSES the account-v2 reducer VERBATIM (a plain redux
 * reducer is a valid NgRx ActionReducer). The consumer is now
 * StoryModalLauncherService.openFromUpgradedLibrary().
 *
 * NB feature key is `storiesLegacyViews` — NOT `stories` (the native StoriesModule
 * already owns a separate `StoreModule.forFeature('stories', ...)` for the
 * photos/quotes views).
 */
import { ActionReducer, createFeatureSelector } from '@ngrx/store';
import storiesReducer from '../../../../account-v2/src/app/features/stories/reducers';

export const STORIES_LEGACY_VIEWS_FEATURE = 'storiesLegacyViews';

export const storiesLegacyViewsReducer = storiesReducer as ActionReducer<any>;

export const selectStoriesLegacyViews = createFeatureSelector<any>(STORIES_LEGACY_VIEWS_FEATURE);
